import './App.css';
import { Home } from './core/components/pages/Home';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './core/components/utils/ScrollTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Home />
      </BrowserRouter>
    </div>
  );
}

export default App;
